import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4680b14f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","width":"100%"} }
const _hoisted_2 = { style: {"flex-basis":"100%"} }
const _hoisted_3 = {
  key: 0,
  class: "catalog-button-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Memo = _resolveComponent("Memo")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue) = $event)),
        disabled: _ctx.disabled,
        "allow-create": _ctx.allowCreating,
        "default-first-option": _ctx.allowCreating,
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        clearable: "",
        multiple: _ctx.multiple,
        placeholder: _ctx.placeholder,
        "remote-method": _ctx.searchAsync,
        loading: _ctx.selectLoadingModel,
        "remote-show-suffix": _ctx.showSuffix,
        "suffix-icon": _ctx.suffixIcon,
        size: _ctx.size,
        onChange: _ctx.onSelectChange
      }, {
        empty: _withCtx(() => [
          _renderSlot(_ctx.$slots, "empty", {}, () => [
            _createTextVNode(" Ничего не найдено ☹️ ")
          ], true)
        ]),
        label: _withCtx((item) => [
          _renderSlot(_ctx.$slots, "label", _normalizeProps(_guardReactiveProps(item)), () => [
            _createTextVNode(" default label template "),
            _createElementVNode("div", null, _toDisplayString(item), 1)
          ], true)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectItems, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              value: item.id
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default", _mergeProps({ ref_for: true }, item), () => [
                  _createTextVNode(" default template "),
                  _createElementVNode("div", null, _toDisplayString(item), 1)
                ], true)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 3
      }, 8, ["modelValue", "disabled", "allow-create", "default-first-option", "multiple", "placeholder", "remote-method", "loading", "remote-show-suffix", "suffix-icon", "size", "onChange"])
    ]),
    (_ctx.catalogTab?.view)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_icon, {
            onClick: _ctx.onPickFromCatalogClick,
            style: _normalizeStyle({ margin: (_ctx.size == 'small' ? '2px 4px 0' : '6px 8px 0 8px') }),
            size: "large"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Memo)
            ]),
            _: 1
          }, 8, ["onClick", "style"])
        ]))
      : _createCommentVNode("", true)
  ]))
}